import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=ffba6624"
import script from "./Particles.vue?vue&type=script&lang=js"
export * from "./Particles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports